module.exports = __webpack_public_path__ + "media/slow2.c5a04155.mp4";